import VIDABOO_CONSTANTS from '../../config/consts';
import { MediaRestService } from './restServices';
import storageService from '../storageService';

const service = {};

service.saveMediaMessageByChatRoomId = async (
  senderObjectType,
  senderObjectId,
  chatRoomId,
  base64data,
  sendAudioMessageNotification,
) => {
  let currentTime = new Date();
  let mediaMessageDto = {};
  mediaMessageDto.senderObjectType = senderObjectType;
  mediaMessageDto.senderObjectId = senderObjectId;
  mediaMessageDto.chatRoomId = chatRoomId;
  mediaMessageDto.voiceMsgBase64 = base64data;
  mediaMessageDto.senderCreationTime = currentTime.getTime();
  // mediaMessageDto.mediaType = VIDABOO_CONSTANTS.MEDIA_MESSAGE_TYPES.AUDIO;
  try {
    const response = await MediaRestService.save(
      {
        endpoint: 'mediaMessage',
        endpointParam: '',
        endpoint2: 'roomId',
        endpointParam2: chatRoomId,
      },
      { mediaMessageDto, token: storageService.getItem('token') },
    );
    if (response.status === 200) {
      sendAudioMessageNotification(response.data.mmDto.mediaMessageId);
    }
  } catch (error) {
    console.debug(error);
  }
};

service.getVoiceMsgByMsgId = async (voiceMsgId) => {
  try {
    const response = await MediaRestService.get(
      {
        endpoint: 'mediaMessage/mediaMessageId',
        endpointParam: voiceMsgId,
        endpoint2: 'userId', // used for guest users only. When mentor keep empty.
        endpointParam2: storageService.getItem('guestUid'),
      },
      { token: storageService.getItem('token') },
    );
    const fileName = response.data.mmDto.tempAccessibleUrl;
    return VIDABOO_CONSTANTS.MEDIA_MESSAGES_STORAGE + fileName;
  } catch (error) {
    console.debug(error);
  }
};

const mediaMessageService = { ...service };
export default mediaMessageService;
